// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3Jj12","card":"Cards_card__A5_1q","infected":"Cards_infected__1HZG4","recovered":"Cards_recovered__3EW8_","deaths":"Cards_deaths__21om8"};